// @flow
// 今後はapp/javascript/config/settings.js.erbを使うようにする
export default {
  app: {
    name: 'FUNDOOR',
    isMufg: false,
  },
  validations: {
    maxFileSize: '10485760'
  },
  helpUrl: 'https://help.fundoor.com/ja/',
  google: {
    universalAnlytics: {
      userID: 'UA-72221753-9'
    }
  },
  documents: {
    maxFileSize: 62914560
  },
  irs: {
    maxFileSize: 52428800,
    defaultExtension: ["png", "jpg", "jpeg", "gif", "pdf", "xls", "xlsx", "doc", "docx", "ppt", "pptx"]
  },
  officerApprovals: {
    maxFileSize: 31457280,
    defaultExtension: ["png", "jpg", "jpeg", "pdf", "xls", "xlsx", "doc", "docx"],
    resolutionReport: {
      maxFileSize: 62914560
    }
  },
  bizReports: {
    maxFileSize: 60000000,
    limitWordNumber: 20000,
    defaultExtension: ["image/png", "image/jpeg", "image/gif"]
  },
  matchings: {
    maxFileSize: 5242880,
    defaultExtension: ["png", "jpg", "jpeg"]
  },
  pitches: {
    maxFileSize: 10485760,
    defaultExtension: ["pdf"]
  },
  companySettings: {
    maxFileSize: 5242880,
    defaultExtension: ["png", "jpg", "jpeg"]
  },
  linkedServices: {
    maxFileSize: 5242880,
    defaultExtension: ["png", "jpg", "jpeg", "gif"]
  }
}
